import { Box, Link, Typography } from '@mui/material';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Tiktok from '@/components/shared/icons/tiktok';
import TwitchIcon from '@/components/shared/icons/twitch';

// Configuración de plataformas sociales
export const SOCIAL_PLATFORMS = [
    {
        key: 'twitter',
        name: 'Twitter',
        baseUrl: 'https://x.com/',
        icon: <XIcon sx={{ fontSize: 18 }} />,
    },
    {
        key: 'youtube',
        name: 'YouTube',
        baseUrl: 'https://www.youtube.com/@',
        icon: <YouTubeIcon sx={{ fontSize: 18 }} />,
    },
    {
        key: 'tiktok',
        name: 'TikTok',
        baseUrl: 'https://www.tiktok.com/@',
        icon: <Tiktok width={16} height={16} />,
    },
    {
        key: 'twitch',
        name: 'Twitch',
        baseUrl: 'https://www.twitch.tv/',
        icon: <TwitchIcon styles={{ width: '16px', height: '16px' }} />,
    },
];

/**
 * Hook para obtener las redes sociales activas de un usuario
 * @param {Object} userSocial - Objeto con las redes sociales del usuario
 * @returns {Array} Array de objetos con las redes sociales activas
 */
export const useActiveSocials = (userSocial) => {
    if (!userSocial) return [];

    return SOCIAL_PLATFORMS.filter((platform) => userSocial[platform.key]).map((platform) => ({
        ...platform,
        username: userSocial[platform.key],
        url: `${platform.baseUrl}${userSocial[platform.key]}`,
    }));
};

/**
 * Componente para renderizar los links de redes sociales
 * @param {Object} userSocial - Objeto con las redes sociales del usuario
 * @param {Boolean} compact - Si es true, muestra versión compacta sin texto
 * @param {Object} sx - Estilos adicionales para el contenedor
 */
const SocialNetworkLinks = ({ userSocial, compact = false, sx = {} }) => {
    const activeSocials = useActiveSocials(userSocial);

    if (activeSocials.length === 0) return null;

    return (
        <Box sx={{ display: 'flex', gap: compact ? 0.5 : 1, flexWrap: 'wrap', ...sx }}>
            {activeSocials.map((social) => (
                <Link
                    key={social.key}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: compact ? 0 : 0.5,
                        textDecoration: 'none',
                        color: 'text.primary',
                        bgcolor: 'background.paper',
                        px: compact ? 0.5 : 1,
                        py: compact ? 0.25 : 0.5,
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'border.main',
                        transition: 'all 0.2s',
                        minWidth: compact ? 32 : 'auto',
                        justifyContent: 'center',
                        '&:hover': {
                            bgcolor: 'action.hover',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    {social.icon}
                    {!compact && (
                        <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>{social.name}</Typography>
                    )}
                </Link>
            ))}
        </Box>
    );
};

export default SocialNetworkLinks;
